import React,{useState} from "react"
// import Logo from "../assests/logo_2-nobag.png"
import "./Homepage.css"
import { Link } from "react-scroll"


const Homepage=()=>{
    const [click, setClick] = useState(false)
    const closeMenu = () => setClick(false)
    return <>
    {/* <header className=" "> */}
        <div className="container-fluid img-fluid header" id="home"></div>
        <div className="container-fluid">
        <nav className="navbar"> 
            {/* <div className="logo"><img src={Logo} alt="React" className="logo"/></div> */}
            
                <ul className="nav-links">
                    <input type="checkbox" id="checkbox_toggle"/>
                    <label for="checkbox_toggle" className="hamburger">&#9776;</label>
                    <div className="menu">
                    <li className="nav-item"><Link to="home" spy={true} smooth={true} offset={50} duration={350} onClick={closeMenu}>Home</Link></li>
                    <li className="nav-item"><Link to="about" spy={true} smooth={true} offset={50} duration={350} onClick={closeMenu}>Know Me</Link></li>
                    <li className="nav-item"><Link to="project" spy={true} smooth={true} offset={50} duration={350} onClick={closeMenu}>Project</Link></li>
                    <li className="nav-item"><Link to="contact" spy={true} smooth={true} offset={50} duration={350} onClick={closeMenu}>Contact Me</Link></li>
                    </div>
                </ul>
            
        </nav>
        <div className="header-sec">
        <h1>Shubhra Srivastava</h1>
        <h2>Full Stack Web Developer</h2>
        <p>Empowering digital experiences as a versatile full-stack developer, bridging the realms of front-end finesse and back-end brilliance!!</p>
        </div>
        </div>
    </>
}

export default Homepage;